module.exports = __webpack_public_path__ + "img/starvation_species_fish.924b2938.svg";